export default "/img/IT.763e6a9993d25c0eb1aa76df705a5865.png";